export enum RoleType {
    Root = 1,
    SuperAdmin = 2,
    ProjectDeveloper = 3,
    ProjectTester = 4,
    Management = 5,
    ReportManagement = 6
}